import React from 'react';
import { STATUS_COLOR, STATUS_BORDER_COLOR } from '../constant';

function Legend({ type = 'Actual' }) {
  if (type === 'Plan') {
    return (
      <DotName
        name="Annual Leave Planned"
        dotColor={STATUS_COLOR?.planned}
        dotBorderColor={STATUS_BORDER_COLOR?.planned}
        nameColor={STATUS_BORDER_COLOR?.planned}
      />
    );
  }

  return (
    <div className="d-flex align-items-center justify-content-center gap-3">
      <DotName
        name="Annual Leave"
        dotColor={STATUS_COLOR?.['annual leave']}
        dotBorderColor={STATUS_BORDER_COLOR?.['annual leave']}
        nameColor={STATUS_BORDER_COLOR?.['annual leave']}
      />

      <DotName
        name="Holiday"
        dotColor={STATUS_COLOR?.holiday}
        dotBorderColor={STATUS_BORDER_COLOR?.holiday}
        nameColor={STATUS_BORDER_COLOR?.holiday}
      />
      <DotName
        name="Sick Leave"
        dotColor={STATUS_COLOR?.['sick leave']}
        dotBorderColor={STATUS_BORDER_COLOR?.['sick leave']}
        nameColor={STATUS_BORDER_COLOR?.['sick leave']}
      />
      <DotName
        name="Other Leave"
        dotColor={STATUS_COLOR?.['other leave']}
        dotBorderColor={STATUS_BORDER_COLOR?.['other leave']}
        nameColor={STATUS_BORDER_COLOR?.['other leave']}
      />
      <DotName
        name="Weekend"
        dotColor={STATUS_COLOR?.weekend}
        dotBorderColor={STATUS_BORDER_COLOR?.weekend}
        nameColor="#667085"
      />
    </div>
  );
}

export default Legend;

function DotName({
  dotColor = '#000000',
  dotBorderColor = '#000000',
  name = '#000000',
  nameColor = '#000000',
  hasDot = true,
}) {
  return (
    <div>
      <span>
        {hasDot && (
          <span
            style={{
              display: 'inline-block',
              width: '10px',
              height: '10px',
              borderRadius: '50%',
              backgroundColor: dotColor,
              border: `2px solid ${dotBorderColor}`,
              marginRight: '5px',
            }}
          />
        )}
        <span style={{ fontSize: '14px', color: nameColor }}>
          <strong>{name}</strong>
        </span>
      </span>
    </div>
  );
}
